<template>
  <v-container
    fluid
    class="d-flex justify-center"
  >
    <v-row>
      <v-col />
      <v-col
        cols="12"
        sm="6"
        md="6"
        lg="5"
        class="d-flex justify-center align-center pa-5 pr-md-7 pr-lg-16 mr-lg-16 pr-xl-16"
      >
        <v-tabs
          grow
          class="bcolor-transparent"
        >
          <v-tab
            class="bcolor-transparent"
          >
            Авторизация
          </v-tab>
          <v-tab class="bcolor-transparent">
            Регистрация
          </v-tab>
          <v-tab-item
            class="bcolor-transparent"
            :transition="false"
          >
            <v-card
              flat
              class="bcolor-transparent rounded-0"
            >
              <v-card-text class="rounded-0">
                <v-text-field
                  v-model="form.phoneNumber"
                  v-mask="'+7(###)##-###-##'"
                  background-color="white"
                  filled
                  label="Номер телефона"
                  placeholder="+7XXXXXXXXXX"
                >
                  <template v-slot:prepend>
                    <v-icon color="white">
                      mdi-phone-classic
                    </v-icon>
                  </template>
                </v-text-field>
                <v-text-field
                  v-model="form.password"
                  background-color="white"
                  filled
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showPassword ? 'text' : 'password'"
                  label="Пароль"
                  @click:append="showPassword = !showPassword"
                >
                  <template v-slot:prepend>
                    <v-icon color="white">
                      mdi-lock
                    </v-icon>
                  </template>
                </v-text-field>
                <v-row v-if="alert.show">
                  <v-col
                    cols="12"
                  >
                    <div
                      style="color: red; text-align: center"
                    >
                      {{ alert.error }}
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions class="d-flex flex-column">
                <v-btn
                  color="primary"
                  @click="onAuth"
                >
                  Войти
                </v-btn>
                <v-btn
                  color="blue lighten-4"
                  text
                  @click="$router.push({name: 'RecoverLoyaltyLink'})"
                >
                  Забыли пароль?
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-tab-item>
          <v-tab-item
            class="bcolor-transparent"
            :transition="false"
          >
            <v-card
              v-if="showRegPhone"
              flat
              class="bcolor-transparent rounded-0"
            >
              <v-form
                ref="formRegPhone"
                v-model="validRegPhone"
              >
                <v-card-title>
                  <div class="text-h4">
                    Вход по номеру телефона
                  </div>
                </v-card-title>
                <v-card-text class="text-center">
                  <v-text-field
                    v-model="form.phoneNumber"
                    v-mask="'+7(###)##-###-##'"
                    background-color="white"
                    filled
                    label="Номер телефона"
                    placeholder="+7XXXXXXXXXX"
                    :rules="phoneRules"
                    hint="Номер телефона на который будет послан код подтверждения"
                  >
                    <template v-slot:prepend>
                      <v-icon color="white">
                        mdi-phone-classic
                      </v-icon>
                    </template>
                  </v-text-field>
                  <v-btn
                    color="blue lighten-4"
                    text
                    @click="onRegEmail"
                  >
                    Регистрация по паролю
                  </v-btn>
                </v-card-text>
                <v-card-actions class="d-flex justify-center">
                  <v-btn
                    color="primary"
                    :disabled="!validRegPhone"
                    @click="onRegGetCode"
                  >
                    Получение кода
                  </v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
            <v-card
              v-if="showRegOtp"
              flat
              class="bcolor-transparent rounded-0"
            >
              <v-card-title>
                Введите код подтверждения, который отправили Вам на номер
              </v-card-title>
              <v-card-text class="d-flex flex-column justify-center">
                <v-text-field
                  v-model="reg_confirm_code"
                  v-mask="'######'"
                  width="6px"
                  filled
                  placeholder="Введите код из 6 цифр"
                  counter="6"
                  required
                  @input="onRegEnterCode"
                >
                  <template v-slot:prepend>
                    <v-icon color="white">
                      mdi-numeric
                    </v-icon>
                  </template>
                </v-text-field>
                <span class="text-center">
                  {{ textRemaining }}
                </span>
                <v-row
                  v-if="alert.show"
                  class="text-center"
                >
                  <v-col
                    cols="12"
                  >
                    <div
                      style="color: red;"
                    >
                      {{ alert.error }}
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions class="d-flex flex-column">
                <v-btn
                  v-if="showRepeatCode"
                  color="blue lighten-4"
                  @click="onRegGetCode"
                >
                  Повторно получить код
                </v-btn>
                <v-btn

                  color="blue lighten-4"
                  text
                  @click="onRegEmail"
                >
                  Регистрация по паролю
                </v-btn>
              </v-card-actions>
            </v-card>
            <v-card
              v-if="showRegEmail"
              flat
              class="bcolor-transparent rounded-0"
            >
              <v-form
                ref="form"
                v-model="validRegEmail"
              >
                <v-card-text>
                  <v-row>
                    <v-col>
                      <v-text-field
                        v-model="form.phoneNumber"
                        v-mask="'+7(###)##-###-##'"
                        prepend-icon="mdi-phone-classic"
                        background-color="white"
                        filled
                        required
                        label="Номер телефона"
                        placeholder="+7XXXXXXXXXX"
                        :rules="phoneRules"
                      />
                    </v-col>
                    <v-col>
                      <v-text-field
                        v-model="form.email"
                        prepend-icon="mdi-email"
                        background-color="white"
                        filled
                        required
                        label="Адрес электронной почты"
                        :rules="emailRules"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-text-field
                        v-model="form.name"
                        prepend-icon="mdi-account"
                        background-color="white"
                        filled
                        label="Имя"
                        :rules="nameRules"
                        required
                      />
                    </v-col>
                    <v-col>
                      <v-text-field
                        v-model="form.surname"
                        prepend-icon="mdi-account-plus"
                        background-color="white"
                        filled
                        label="Фамилия"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        v-model="form.password"
                        prepend-icon="mdi-lock"
                        background-color="white"
                        filled
                        required
                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="showPassword ? 'text' : 'password'"
                        :rules="passwordRules"
                        label="Пароль"
                        @click:append="showPassword = !showPassword"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        v-model="form.password2"
                        prepend-icon="mdi-lock"
                        background-color="white"
                        filled
                        required
                        :append-icon="showPassword2 ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="showPassword2 ? 'text' : 'password'"
                        :rules="passwordRules"
                        label="Повторить пароль"
                        @click:append="showPassword2 = !showPassword2"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="py-0">
                      <v-checkbox
                        color="white"
                        class="mt-0"
                      >
                        <template v-slot:label>
                          <span style="color: white;">Я принимаю Условия пользовательского соглашения</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="py-0">
                      <v-checkbox
                        color="white"
                        class="mt-0"
                      >
                        <template v-slot:label>
                          <span style="color: white;">Я принимаю Условия программы лояльности</span>
                        </template>
                      </v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row
                    v-if="alert.show"
                    class="text-center"
                  >
                    <v-col
                      cols="12"
                    >
                      <div
                        style="color: red;"
                      >
                        {{ alert.error }}
                      </div>
                    </v-col>
                  </v-row>
                  <v-row class="text-center">
                    <v-col
                      class="py-0"
                      cols="12"
                    >
                      <v-btn
                        color="blue lighten-4"
                        text
                        @click="showRegEmail=false; showRegPhone=true"
                      >
                        Регистрация по СМС коду
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions class="d-flex justify-center">
                  <v-btn
                    color="primary"
                    :disabled="!validRegEmail || form.password !== form.password2"
                    @click="onRegByPassword"
                  >
                    Зарегистрироваться
                  </v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { TheMask } from "vue-the-mask"
import WebApi from "@/views/loyalty/shared/modules/web_api"
import { localStock } from "@/views/loyalty/shared/classes/local_stock"
import { isNotExists } from "@/views/loyalty/shared/modules/utilities"
import { JustpayClient } from "@/views/loyalty/shared/services/justpay-client-service"
import { LoginService } from "@/views/loyalty/shared/services/login-service"
export default {
  name: "LoginLoyalty",
  components: { TheMask },
    data: () => ({
      alert: {
        show: false,
        error: '',
      },
      customerId: null,
      form: {
        email: '',
        surname: '',
        name: '',
        phoneNumber: '',
        password: '',
        password2: '',
      },
      emailRules: [
        v => !!v || 'Адрес электронной почты обязателен',
        v => /.+@.+\..+/.test(v) || 'Адрес электронной почты не верно',
      ],
        loginService: null,
      nameRules: [
        v => !!v || 'Имя пользователя обязательно',
        // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
      ],
      phoneRules: [
          v => !!v || 'Номер телефона обязателен',
        v => (v && v.length >= 12) || 'Номер телефона должен содержать, не менее 12 символов',
      ],
      passwordRules: [
          v => !!v || 'Пароль обязателен',
        v => (v && v.length >= 6) || 'Пароль должен содержать, не менее 6 символов',
      ],
    reg_confirm_code: '',
    reg_got_code: '',
    showRegPhone: true,
    showRegOtp: false,
    showRegEmail: false,
      showRepeatCode: false,
      showPassword: false,
      showPassword2: false,
      textRemaining: '',
      timerId: 0,
      validRegEmail: false,
      validRegPhone: false,
      webApi: null,
  }),
  async beforeMount () {
    this.webApi = new WebApi(this.$store)
      this.loginService = new LoginService()
    if (this.$route.query.id !== undefined) {
      this.customerId = this.$route.query.id
      localStorage.setItem('customer', this.$route.query.id)
        // await this.getCustomerNumber()
        this.customerNumber = this.$route.query.number
        localStorage.setItem('customerNumber', this.customerNumber)
    }
    console.log('route.query', this.customerId)
  },
  methods: {
      // async getCustomerNumber () {
      //     const token = await this.loginService.getToken()
      //     console.log('token', token)
      //     localStorage.setItem('token', token)
      //     const justpayClientService = new JustpayClient()
      //     this.customerNumber = await justpayClientService.getClientNumber(this.customerId)
      //     localStorage.setItem('customerNumber', this.customerNumber)
      //     localStorage.removeItem('token')
      // },
    getRouteName (obj) {
      // console.log('obj', obj)
      if (!isNotExists(obj.email) && !isNotExists(obj.name) && !isNotExists(obj.surname)) {
        if (obj.email.length > 0 && obj.name.length > 0 && obj.surname.length > 0) {
          return 'CrowdAccount'
        } else {
          return 'CrowdProfile'
        }
      } else {
        console.log('to ClearInterval')
        clearInterval(this.timerId)
        this.reg_got_code = null
        this.textRemaining = 'Произошла ошибка'
      }
    },
    async onAuth () {
        const response = await this.loginService.getLogin(this.form)
        if (response.data) {
            localStock.setItem('userProfile', response.data)
            localStorage.setItem('userProfileId', response.data.userProfileId)
            localStorage.removeItem('client')
            localStorage.setItem('login', this.form.phoneNumber)
            // localStorage.setItem('token', response.data.access_token)
            this.alert.show = false
            await this.$router.push({ name: this.getRouteName(response.data) })
        } else {
            this.alert.error = response.error
            this.alert.show = true
        }
    },
    async onRegByPassword () {
      this.form.phoneNumber = this.form.phoneNumber.replace(/[+()-]/g, '')
        const response = await this.loginService.createLogin({ customerId: this.customerId, customerNumber: this.customerNumber, ...this.form })
        if (response.data) {
            console.log('***Success!***')
              console.log('response', response.data)
              localStock.setItem('userProfile', response.data)
              localStorage.setItem('userProfileId', response.data.userProfileId)
              localStorage.removeItem('client')
              localStorage.setItem('login', this.form.phoneNumber)
              // localStorage.setItem('token', response.token)
              if (!response.error) {
                  this.alert.show = false
                  await this.$router.push({ name: this.getRouteName(response.data) })
              }
        } else {
            this.alert.error = response.error
            this.alert.show = true
        }
    },
    onRegEmail () {
      this.showRegEmail = true
      this.showRegPhone = false
      this.showRegOtp = false
    },
    async onRegEnterCode () {
      // console.log('this.reg_confirm_code.length == ' + this.reg_confirm_code.length)
      if (this.reg_confirm_code == this.reg_got_code) {
        console.log('this.reg_confirm_code.length is 6, go to UserProfile')
        // clearInterval(this.timerId)
        this.showRepeatCode = true
          const response = await this.loginService.createLogin({ customerId: this.customerId, customerNumber: this.customerNumber, ...this.form })
          if (response.data) {
              console.log('***Success!***')
              console.log('response', response.data)
              localStock.setItem('userProfile', response.data)
              localStorage.setItem('userProfileId', response.data.userProfileId)
              localStorage.removeItem('client')
              localStorage.setItem('login', this.form.phoneNumber)
              // localStorage.setItem('token', response.token)
              if (!response.error) {
                  this.alert.show = false
                  await this.$router.push({ name: this.getRouteName(response.data) })
              }
          } else {
              this.alert.error = response.error
              this.alert.show = true
              clearInterval(this.timerId)
              this.reg_got_code = null
              this.textRemaining = ""
          }
      }
    },
    onRegGetCode () {
      console.log('Getting a code')
      this.showRegPhone = false
      this.showRegEmail = false
      this.showRegOtp = true
      this.showRepeatCode = false

      this.webApi.post(`${process.env.VUE_APP_LOYALTY_URL}api/confirm_code/`, { phone: this.form.phoneNumber }).then((response) => {
        // console.log('response', response)
        this.reg_got_code = response
      })

      const end = new Date()
      const minutes = end.getMinutes()
      const interval = 3 // minutes
      clearInterval(this.timerId)
      end.setMinutes(minutes + interval)
      this.timerId = setInterval(this.showRemaining, 1000, end)
      console.log('timerId', this.timerId)
    },
    showRemaining (end) {
      // console.log(' inner timerId', this.timerId)
      const now = new Date()
      const distance = end.getTime() - now.getTime()
      // console.log('distance=' + distance)
      if (distance < 0) {
        clearInterval(this.timerId)
        this.reg_got_code = null
        this.showRepeatCode = true
        return
      }
      const minutes = Math.floor(distance / 60000)
      const seconds = Math.floor((distance % 60000) / 1000)
      this.textRemaining = `Осталось времени ${minutes} мин. ${seconds} сек.`
    },
  }
}
</script>

<style scoped>
.main-loyalty {
    background-image: url("/black-friday-gift.png");
    background-size: cover;
}
.bcolor-transparent {
    background-image: url("/background-friday-gift.png");
    background-size: cover;
    color: white;
    border-radius: 0;
}
.check-box-color {
    color: white !important;
}

</style>
